"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
function selectCurrentTab(tab) {
  return (0, _utils.actionCreator)(_types.BROACAST_SOURCES_SELECT_TAB, tab);
}
var _default = exports["default"] = selectCurrentTab;